import React from 'react';

import PropTypes from 'prop-types';
import { compose } from 'underscore';
import FluxibleComponent from 'vendor/cnpm/fluxible.v0-4/addons/FluxibleComponent';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import connectToRouter from 'js/lib/connectToRouter';

import app from 'bundles/discussions/app';
import withDiscussionPrompt from 'bundles/discussions/components/discussionPrompt/withDiscussionPrompt';
import discussionsForumsHOC from 'bundles/discussions/components/discussionsForumsHOC';
import routerConnectToCurrentForum from 'bundles/discussions/utils/routerConnectToCurrentForum';

const discussionPromptContainer = () => {
  return withDiscussionPrompt;
};

const ConnectedDiscussionPrompt = compose(
  discussionsForumsHOC({ fields: ['forumType', 'urlId'] }),
  connectToRouter((router, props) => ({
    ...routerConnectToCurrentForum(router, props),
    page: router.location.query.page ? parseInt(router.location.query.page, 10) : 1,
    answerId: router.location.query.answerId ? router.location.query.answerId : undefined,
  })),
  // @ts-expect-error ts-migrate(2339) FIXME: Property 'itemMetadata' does not exist on type '{}... Remove this comment to see the full error message
  connectToStores(['ThreadDetailsStore'], ({ ThreadDetailsStore }, { itemMetadata }) => {
    return {
      // We have to copy the object because otherwise we can't distinguish between old and new props
      savingStates: Object.assign({}, ThreadDetailsStore.savingStates),
    };
  })
)(discussionPromptContainer());

export default class FluxibleConnectedDiscussionPrompt extends React.Component<$TSFixMe> {
  static contextTypes = {
    fluxibleContext: PropTypes.object,
  };

  componentWillMount() {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'fluxibleContext' does not exist on type ... Remove this comment to see the full error message
    this.fluxibleContext = app(this.context.fluxibleContext);
  }

  render() {
    return (
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'fluxibleContext' does not exist on type ... Remove this comment to see the full error message
      <FluxibleComponent context={this.fluxibleContext.getComponentContext()}>
        <ConnectedDiscussionPrompt {...this.props} />
      </FluxibleComponent>
    );
  }
}
